import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { BetslipNotificationActions } from '../../notifications/betslip-notification.actions';
import { BetslipNotificationMessageType, IBetslipNotificationState } from '../../notifications/state';

@Component({
    selector: 'bs-betslip-edit-my-bet-notification',
    templateUrl: './edit-bet-notification.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet-notification.scss'],
    standalone: false,
})
export class EditMybetNotificationComponent implements OnInit, OnDestroy {
    @Input() notification: IBetslipNotificationState;
    private clickHandler: EventTarget;
    module = EpcotModule.Betslip;
    private readonly _doc = inject(DOCUMENT);

    constructor(private store: Store) {
        this.clickHandler = this._doc.querySelector('.betslip') || this._doc;
    }

    ngOnInit(): void {
        this.clickHandler.addEventListener('click', this.touchstartHandler);
    }

    ngOnDestroy(): void {
        this.clickHandler.removeEventListener('click', this.touchstartHandler);
    }

    get isExtended(): boolean {
        return this.notification.messageType === BetslipNotificationMessageType.Extended;
    }

    private touchstartHandler = () => {
        this.store.dispatch(BetslipNotificationActions.clearMessage());
    };
}
